/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import axios from 'axios';
import { notification } from 'antd';

export const getUiConfig = (config, t) => {
  return axios
    .get(window.location.origin + config.serverConfig.appUiConfigUri)
    .then(res => {
      return res.data;
    })
    .catch(error => {
      notification.error({
        message: t('api_errorMsg'),
        duration: 0,
        description: t('api_loadError', { label: t('label_UIConfigurations') }),
      });
    });
};
